import { watch, type Ref } from "vue"
import { useDataCacheStore } from "~/stores"

/**
 * Composable pour gérer le titre de la page du navigateur
 * Affiche "Espace Client - [Nom Entreprise]" pour les clients
 */
export function usePageTitle() {
    const dataCacheStore = useDataCacheStore()

    function setClientTitle(companyName?: string) {
        const name = companyName || dataCacheStore.data?.COMPANY?.NAME
        if (name) {
            document.title = `Espace Client - ${name}`
        } else {
            document.title = "Espace Client"
        }
    }

    function setManagerTitle() {
        document.title = "Lolapp"
    }

    function setTitle(title: string) {
        document.title = title
    }

    // Watcher pour mettre à jour le titre quand les données de l'entreprise sont chargées
    function watchCompanyAndSetClientTitle() {
        // Mettre à jour immédiatement si les données sont déjà disponibles
        setClientTitle()

        // Watcher pour les mises à jour ultérieures
        watch(
            () => dataCacheStore.data?.COMPANY?.NAME,
            (newName) => {
                if (newName) {
                    setClientTitle()
                }
            },
            { immediate: true },
        )
    }

    // Watcher pour la page de login avec companyDetails réactif
    function watchCompanyDetailsForClientTitle(
        companyDetails: Ref<{ NAME?: string }>,
    ) {
        watch(
            () => companyDetails.value?.NAME,
            (name) => {
                setClientTitle(name)
            },
            { immediate: true },
        )
    }

    return {
        setClientTitle,
        setManagerTitle,
        setTitle,
        watchCompanyAndSetClientTitle,
        watchCompanyDetailsForClientTitle,
    }
}
